export var actionKey = '@@uploads';
//# sourceMappingURL=constants.js.map